import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Eyebrow + title + sub. Used at the top of every dashboard section.
 * API mirrors fresh-dashboard's SectionHeader (eyebrow / title / sub /
 * rightSlot) so prototype code drops in without rewriting prop names.
 */
const PILL_TONES = {
	action: 'bg-action-soft text-action-soft-foreground',
	primary: 'bg-primary-soft text-primary-soft-foreground',
	warning: 'bg-warning-soft text-warning-soft-foreground',
	success: 'bg-success-soft text-success-soft-foreground'
};

const SectionHeader = React.forwardRef(({ className, eyebrow, title, sub, rightSlot, eyebrowPill, ...props }, ref) => {
	const pillTone = typeof eyebrowPill === 'string' ? PILL_TONES[eyebrowPill] : PILL_TONES.success;
	return (
		<div ref={ref} className={cn('mb-5 flex items-start justify-between gap-4', className)} {...props}>
			<div className="min-w-0">
				{eyebrow ? (
					eyebrowPill ? (
						<span
							className={cn(
								'mb-1.5 inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-[0.14em]',
								pillTone
							)}
						>
							{eyebrow}
						</span>
					) : (
						<div className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{eyebrow}</div>
					)
				) : null}
				{title ? <h2 className="text-xl font-extrabold text-foreground md:text-2xl">{title}</h2> : null}
				{sub ? <p className="mt-1 text-sm text-muted-foreground">{sub}</p> : null}
			</div>
			{rightSlot ? <div className="shrink-0">{rightSlot}</div> : null}
		</div>
	);
});
SectionHeader.displayName = 'SectionHeader';

export { SectionHeader };
